<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title">
      {{ 'apollo-subscriptions.creditcard-payment.title' | translate }}
    </h2>
  </div>
  <div class="modal-body">
    <div class="row">
      <div
        class="col"
        [ngClass]="{ 'is-loading is-loading-lg': loading.token }"
      >
        <form
          action="/"
          method="post"
          id="cc-form"
          class="inspectlet-sensitive row"
        >
          <div class="col-12">
            <div class="form-group">
              <label for="cc-number">{{ 'Card number' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fe fe-credit-card"></i>
                  </div>
                </div>
                <div
                  id="cc-number"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="invalidFields.number"
                ></div>
              </div>
            </div>
          </div>

          <div class="col-7">
            <div class="form-group">
              <label for="cc-validity">{{ 'Valid till' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fe fe-calendar"></i>
                  </div>
                </div>
                <div
                  id="cc-validity"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="invalidFields.expirationDate"
                ></div>
              </div>
            </div>
          </div>

          <div class="col pl-2">
            <div class="form-group">
              <label for="cc-cvv">{{ 'CVV' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fe fe-hash"></i></div>
                </div>
                <div
                  id="cc-cvv"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="invalidFields.cvv"
                ></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-outline-secondary mr-auto"
      type="button"
      (click)="onClose()"
    >
      {{ 'Cancel' | translate }}
    </button>

    <button
      class="btn btn-primary"
      type="button"
      (click)="onPay()"
      [disabled]="loading.pay || loading.token"
    >
      {{ 'Pay' | translate }} ({{ total | pepCurrency: 'EUR':locale:2:0 }})
      <span *ngIf="loading.pay"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
